module.exports = __webpack_public_path__ + "img/PusherTug.ef45ca27.png";